module.exports = __webpack_public_path__ + "static/media/Salta.48dc0fec.svg";